<template>
  <div class="single-product">

    <Breadcrumb :links="links"/>

    <button class="back-button" @click="$router.go(-1)">{{ translations.back }}</button>

    <div class="single-product__data">
      <Gallery :thumbnail="singleProduct.thumbnail" :images="images" :key="$route.params.slug" />

      <p v-if="attributeAboveName" class="attribute-above-name">{{attributeAboveName}}</p>

      <h1 class="product-name">{{ singleProduct.name }}</h1>
      
      <p class="product-sku">{{ singleProduct.sku }}</p>

      <div class="products-layout">
      <ProductTable
        v-if="singleProduct && type === 'wells'"
        :displayedProducts="[singleProduct]"
        :hideImage="true"
        :hideName="true"
        :hideSKU="true"
      />

      <ProductGrid
        v-else-if="singleProduct && type === 'kaali'"
        :displayedProducts="[singleProduct]"
        :hideImage="true"
        :hideName="true"
        :hideSKU="true"
        :additionalInfo="additionalInfo"
      />
      </div>

      <ProductAttributes v-if="attributes.length > 0 && type != 'wells'" :attributes="attributes"></ProductAttributes>

      <Description
      :excerpt="singleProduct.excerpt"
      :description="singleProduct.description"
      ></Description>

      <ProductFiles :files="files" :displayHR="true" v-if="Object.keys(files).length" />
      <hr />
      <div class="product-social">
        <p>
          {{ translations.shareText }}
        </p>
        <facebook-button :shareUrl="singleProduct.permalink" :shareDescription="shareDescription" />
      </div>
    </div>

    <ProductsDisplay
      v-if="relatedProducts.length > 0"
      :title="translations.relatedProducts"
      :type="'wells'"
      :products="relatedProducts"
      :isLoading="relatedProductsLoading"
      :isCarousel="true"
    />
  </div>
</template>

<script>
import FacebookButton from "vue-share-buttons/src/components/FacebookButton.vue";
import ProductTable from "@/layouts/archive/product-grid/table/Wells.vue";
import ProductGrid from "@/layouts/archive/product-grid/grid/Kaali.vue";
import Gallery from "@/layouts/general-ui/Gallery.vue";
import Description from "@/layouts/general-ui/Description.vue";
import Breadcrumb from "@/layouts/general-ui/Breadcrumb.vue";
import ProductsDisplay from "@/layouts/single/ProductsDisplay.vue";
import ProductFiles from "@/components/single/productfiles/Wells.vue";
import ProductAttributes from "@/components/single/attributes/Wells.vue";

export default {
  name: "Product",
  components: {
    FacebookButton,
    ProductTable,
    ProductGrid,
    Gallery,
    Description,
    ProductsDisplay,
    ProductFiles,
    ProductAttributes,
    Breadcrumb
  },
  data() {
    return {
      type: ws_vue_store.config["product-grid"],
      files: {},
      images: [],
      attributes: [],
      description: "",
      additionalInfo: "",
      singleProduct: false,
      relatedProducts: [],
      relatedProductsLoading: true,
      translations: {
        shareText: ws_vue_store.translations.share_text,
        files: ws_vue_store.translations.files,
        back: ws_vue_store.translations.back,
        readMore: ws_vue_store.translations.read_more,
        relatedProducts: ws_vue_store.translations.related_products
      }
    };
  },
  mounted() {
    this.getSingleProduct;
  },
  watch: {
    $route(to, from) {
      this.getSingleProduct;
    }
  },
  computed: {
    getSingleProduct() {
      window.scrollTo(0, 0);
      /*if (this.$store.state.products.length === 0) {
        return false;
      }*/

      this.getProduct();

      return false;
    },
    shareDescription() {
      if (!this.singleProduct.excerpt) {
        return "";
      }
      return this.singleProduct.excerpt.substring(0, 120);
    },
    links(){
      let links = [];

      // SHOP URL
      if(ws_vue_store.shop_url != undefined){
        links.push({
          text: ws_vue_store.translations.shop,
          href: ws_vue_store.shop_url
        }) 
      }

      // MAIN CATEGORY AND SUB CATEGORY
      let currentCat = this.$store.state.filters.current;
      let singleProductTaxonomies = this.singleProduct.taxonomies;
      if(currentCat != undefined && currentCat.product_cat != undefined){
        if(this.singleProduct != undefined && this.singleProduct != false){
          let categoryId = singleProductTaxonomies.product_cat.includes(currentCat.product_cat[0]) ? currentCat.product_cat[0] : singleProductTaxonomies.product_cat[0];
          let categoryInfo = this.$store.state.categories.find(category => category.term_id == categoryId);
          if(categoryInfo != undefined){
            if(categoryInfo.parent != 0){
              let parentCategory = this.$store.state.categories.find(category => category.term_id == categoryInfo.parent);
              links.push({
                text: parentCategory.name,
                href: ws_vue_store.base_url + ws_vue_store.sub_urls.category_base + '/' + parentCategory.slug
              });
            }
            links.push({
              text: categoryInfo.name,
              href: ws_vue_store.base_url + ws_vue_store.sub_urls.category_base + '/' + categoryInfo.slug
            });
          }
        }
      }

      // PRODUCT
      if(this.singleProduct){
        links.push({
          text: this.singleProduct.name,
          href: (ws_vue_store.base_url + this.singleProduct.permalink).replace('//', '/')
        });
      }
      
      return links
    },
    attributeAboveName(){
      if(ws_vue_store.config['single-product-attribute-above-name'] == undefined && this.attributes == false) return false;
      
      let attribute = this.attributes.find(attr => attr.key == ws_vue_store.config['single-product-attribute-above-name']);
      if(attribute){
        return attribute.options.map(option => option.name).join(' ');
      }

      return false;
    }
  },
  methods: {
    getProduct() {
      const self = this;
      const url = ws_vue_store.product_by_slug_endpoint + this.$route.params.slug;
      self.getProductFullInfo(this.$route.params.slug);
      const result = this.axios.get(url).then(function(res){
        if (res && res.data && res.data.state == 'OK') {
          self.singleProduct = res.data.data;
          self.attributes = res.data.data.attributes;
          self.relatedProducts = res.data.data.related_products;
          self.$store.commit("addProductToViewedList", res.data.data);
        }
      });
    },
    getProductFullInfo(product_slug){
      const self = this;
      const url = ws_vue_store.site_options_endpoint + 'raw';
      const result = this.axios.post(url, {
        'fields': ['options_vue_store_additional_info'],
      }).then(function(res){
        if (res && res.data && res.data.state == 'OK') {
          let additionalInfo = res.data.data.find(option => option.option_name == 'options_vue_store_additional_info');
          if(additionalInfo){
            self.additionalInfo = additionalInfo.option_value;
          }
        }
      });
    }
    /*getProductFullInfo(product_slug) {
      const self = this;
      this.relatedProductsLoading = true;
      this.files = [];
      this.images = [];
      //this.relatedProducts = [];
      this.description = "";
      this.axios
        .get(`${ws_vue_store.ajax_url}?action=wsvs_get_product_full_info&product_slug=${product_slug}`)
        .then(response => {
          if (response.data.success) {
            self.files = response.data.data.files ? response.data.data.files : [];
            self.description = response.data.data ? response.data.data.description : [];
            self.relatedProductsLoading = false;
            self.images = response.data.data.images;
            self.additionalInfo = response.data.data.single_product_additional_info;
          }
        })
        .catch(err => {
          // eslint-disable-next-line
          console.error(err);
        });
    }*/
  }
};
</script>

<style lang="scss" scoped>
.single-product {
  &__data {
    display: grid;
    grid-template-columns: 0.3fr 0.5fr 0.2fr;
    gap: 4rem;
  }
}

.back-button {
  padding: 1rem 2rem;
  color: $color-white;
  background-color: $color-gray;
  display: flex;

  &:before {
    content: "‹";
    display: block;
    margin-right: 0.5rem;
  }
}

.product-name {
  margin-bottom: 2rem;
}

// .arrow {
//   height: 0.1rem;
//   width: 2rem;
//   background-color: $color-plugin;
//   display: block;
//   position: relative;
//   margin: 1rem 1rem 1rem 0;
//   @include smooth-animation;

//   &:after,
//   &:before {
//     content: "";
//     height: 0.1rem;
//     width: 0.8rem;
//     background-color: $color-plugin;
//     display: block;
//     position: absolute;
//     right: 0;
//   }

//   &:before {
//     top: 0;
//     transform: rotate(-45deg);
//     transform-origin: top right;
//   }

//   &:after {
//     bottom: 0;
//     transform: rotate(45deg);
//     transform-origin: bottom right;
//   }
// }

// .read-more {
//   display: inline-flex;
//   align-items: center;
//   @include smooth-animation;
//   margin-top: 2rem;

//   &:hover {
//     .arrow {
//       width: 2.5rem;
//     }
//   }
// }
</style>
